import {useEffect} from 'react';
import {Conversation} from '@stripe-internal/conversations-client';
import {useWidget} from '@stripe-internal/conversations-ui';

export const useConversationTriggerParams = (conversation: Conversation) => {
  const widget = useWidget();

  useEffect(() => {
    const sub = widget.triggerParamsObservable().subscribe(() => {
      const triggerParams = widget.triggerParams();
      if (
        !triggerParams?.initialQuery ||
        triggerParams.initialQuery?.trim() === ''
      ) {
        return;
      }

      conversation.action({
        name: 'handle-trigger-params',
        triggerParams,
      });

      // clear the trigger params now that we've applied them to the conversation.
      // this is to try and protect against them inadvertently being applied
      // to other open callsites that are not providing triggerParams
      widget.setTriggerParams(null);
    });

    return () => sub.unsubscribe();
  }, [widget, conversation]);
};
